import React, { useState } from "react"
import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import clsx from "clsx"
import { SingleCard } from "./SingleCard"
import { SeoCard } from "./SeoCard"
import { CREDIT_CARDS_LIST } from "./data"
import { ICardsListProps } from "./types"
import * as styles from "./cardsList.module.scss"
import { scrollToSwitcherBlock } from "./helper"

export const defaultTitle = "Сравните сами кредитную карту с картой рассрочки* «Халва»"

const showCard = 5

export const CardsList = ({
  headTitle = defaultTitle,
  dataContent = CREDIT_CARDS_LIST,
  orderNum,
  url,
  variantStylesSingleCard,
}: ICardsListProps) => {
  const seoCards = !!dataContent[0]?.ctaButton || !!dataContent[0]?.moreDetails

  const cardWithoutCurrentUrl = dataContent.filter((card) =>
    seoCards ? card.moreDetails !== url : true
  )

  const isShowingAllInitial = cardWithoutCurrentUrl.length < showCard

  const [isShowingAll, setIsShowingAll] = useState(isShowingAllInitial)

  const toggleVisibility = () => {
    if (isShowingAll) {
      scrollToSwitcherBlock()
    }
    setIsShowingAll((prev) => !prev)
  }

  return (
    <section
      className={clsx(styles.section, { [styles.shadow]: !isShowingAll })}
      id="cardsList"
      data-exclude={orderNum}
    >
      <Container>
        {headTitle && <h2 className={styles.headTitle}>{headTitle}</h2>}
        <div className={clsx(styles.wrapper, { [styles.overflow]: isShowingAll })}>
          {seoCards
            ? cardWithoutCurrentUrl?.map((item, index) => <SeoCard key={index} card={item} />)
            : dataContent?.map((card, index) => (
                <SingleCard
                  key={card.title}
                  {...card}
                  dataContent={dataContent}
                  index={index}
                  variantStyles={variantStylesSingleCard}
                />
              ))}
        </div>
        {!isShowingAllInitial && (
          <Button onClick={toggleVisibility} className={styles.btn}>
            {isShowingAll ? "Скрыть..." : "Показать все"}
          </Button>
        )}
      </Container>
    </section>
  )
}
